import { Children, cloneElement, HTMLAttributes, ReactElement, useRef } from 'react';

import { Theme } from '@emotion/react';
import { Box } from '@mui/material';
import { SxProps } from '@mui/system';
import { useVirtualizer } from '@tanstack/react-virtual';

const customStyles: Record<string, SxProps<Theme>> = {
  list: {
    maxHeight: '200px',
    overflowY: 'auto',
    width: '100%',
  },
};

export function MetadataList(props: HTMLAttributes<HTMLElement>) {
  const { children } = props;

  const metadataListRef = useRef();
  const metadataList = Children.toArray(children) as ReactElement[];

  const rowVirtualizer = useVirtualizer({
    count: metadataList.length,
    getScrollElement: () => metadataListRef.current,
    estimateSize: () => 34,
  });

  return (
    <Box
      ref={metadataListRef}
      sx={customStyles.list}
    >
      <div
        style={{
          height: `${rowVirtualizer.getTotalSize()}px`,
          width: '100%',
          position: 'relative',
        }}
      >
        {rowVirtualizer.getVirtualItems().map((virtualItem) => {
          return cloneElement(metadataList[virtualItem.index], {
            key: String(virtualItem.key),
            style: {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              transform: `translateY(${virtualItem.start}px)`,
            },
            onMouseDown: (event: MouseEvent) => {
              event.preventDefault();
            },
          });
        })}
      </div>
    </Box>
  );
}
